import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Carousel, Icon, Input, Modal, notification} from 'antd';
import {isModalOpened, modalData} from '../../../redux/selectors/nav';
import {makeAction} from '../../../redux/actions/makeAction';
import {
  CLOSE_MODAL,
  OPEN_MODAL,
  REQUEST_PROFILE_EDIT_CODE,
  USER_PROFILE_CHANGE,
  VALIDATE_CODE,
} from '../../../redux/actions/actionTypes';
import _ from 'lodash';
import FormError from '../../FormError';
import {profileErrors} from '../../../redux/selectors/error';
import { API_CODE_LENGTH, PROFILE_EDIT_WALLET_MODAL_ID, VerificationCodeType } from '../../../services/constants';
import VerificationCodeForm from '../common/VerificationCodeForm';
import TranslatedText from '../../TranslatedText';
import {withTranslation} from 'react-i18next';
import {ReactComponent as CloseIcon} from '../../../assets/img/close.svg';
import {userEmailSelector} from '../../../redux/selectors/user';
import {ReactComponent as CloseNotificationIcon} from '../../../assets/img/CloseIconNotification.svg';

const defaultState = {
  value: '',
  valueRepeat: '',
  code_invalid: false,
  code: _.range(API_CODE_LENGTH).map(() => ' ').join(''),
};

class ChangeWalletModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {...defaultState};
    this.submit = this.submit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onCodeChange = this.onCodeChange.bind(this);
    this.codeSubmit = this.codeSubmit.bind(this);
    this.resendCode = this.resendCode.bind(this);
    this.carousel = React.createRef();
  }

  submit(event) {
    event.preventDefault();
    this.props.changeUserProfile({
      ...Object.fromEntries(new FormData(event.target)),
      field: 'wallet',
      code: this.state.code,
      callback: () => {
        this.props.closeModal();
        this.cleanup();
        notification.warn({
          message: null,
          className: 'profile-changed-tooltip-card',
          closeIcon: <CloseNotificationIcon/>,
          description: this.props.t('modals.profile.walletChanged'),
          icon: <Icon type="info-circle" />,
        });
      },
    });
  }

  codeSubmit(code) {
    this.setState({code_invalid: false});
    this.props.validateCode({
      code,
      type: VerificationCodeType.UPDATE_FRAGILE_DATA,
      callback: () => {
        this.setState({code});
        this.carousel.current.next();
      },
      onError: () => {
        this.setState({code_invalid: true});
      },
    });
  }

  onCodeChange(code) {
    this.setState({code});
  }

  onCancel() {
    this.props.closeModal();
    this.cleanup();
  }

  cleanup() {
    this.setState(defaultState);
    this.carousel.current.goTo(0);
  }

  resendCode() {
    this.props.requestProfileEditCode({
      email: this.props.email,
    });
  }


  render() {
    return (
      <Modal
        title={<TranslatedText transKey="modals.profile.editWallet"/>}
        className="profile-modal change-wallet-profile-modal"
        width={440}
        visible={this.props.opened}
        onCancel={this.onCancel}
        closeIcon={<CloseIcon/>}
        footer={null}
      >
        <Carousel ref={this.carousel} dots={false} infinite={false}>
          <div>
            <VerificationCodeForm onChange={this.onCodeChange} code={this.state.code} onSubmit={this.codeSubmit}
                                  isInvalid={this.state.code_invalid} onResend={this.resendCode}>
              <Button type="primary" block htmlType="submit">
                <TranslatedText transKey="modals.verification.next"/>
              </Button>
            </VerificationCodeForm>
          </div>
          <div>
            <FormError errors={this.props.errors} fieldName="non_field_errors"/>
            <form onSubmit={this.submit}>
              <div className="modal-form-group">
                <FormError.Tooltip errors={this.props.errors} fieldName="value">
                  <Input placeholder={this.props.t('modals.profile.walletNew')} name="value" value={this.state.value} onChange={e => this.setState({value: e.target.value})} required/>
                </FormError.Tooltip>
              </div>
              <div className="modal-form-group">
                <FormError.Tooltip errors={this.props.errors} fieldName="valueRepeat">
                  <Input placeholder={this.props.t('modals.profile.walletRepeat')} name="valueRepeat" value={this.state.valueRepeat} onChange={e => this.setState({valueRepeat: e.target.value})} required/>
                </FormError.Tooltip>
              </div>
              <Button type="primary" block htmlType="submit">
                <TranslatedText transKey="modals.profile.saveChanges"/>
              </Button>
            </form>
          </div>
        </Carousel>
      </Modal>
    );
  }
}

ChangeWalletModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  data: PropTypes.object,
  errors: PropTypes.object.isRequired,
  changeUserProfile: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  validateCode: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  requestProfileEditCode: PropTypes.func.isRequired,
  email: PropTypes.string,
};

const mapStateToProps = (state) => ({
  opened: isModalOpened(state)(PROFILE_EDIT_WALLET_MODAL_ID),
  data: modalData(state),
  errors: profileErrors(state),
  email: userEmailSelector(state),
});

const mapDispatchToProps = {
  openModal: makeAction(OPEN_MODAL),
  closeModal: makeAction(CLOSE_MODAL),
  changeUserProfile: makeAction(USER_PROFILE_CHANGE),
  validateCode: makeAction(VALIDATE_CODE),
  requestProfileEditCode: makeAction(REQUEST_PROFILE_EDIT_CODE),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ChangeWalletModal));



// WEBPACK FOOTER //
// /src/components/modals/profile/ChangeWalletModal.jsx